// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconFrance_icon__tqO8i"};